import { viewModelDecorator, extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import template from './assets/template.html';
import './assets/styles.scss';

@viewModelDecorator({
    defaults() {
        return {
            firstPaymentPrice: '',
            show: false,
            price: '',
            userCloseTooltip: false,
        };
    },
})
@extendDecorator({
    bindings: {
        '.js-tooltip-price': 'text: price',
        '.js-tooltip-percent': 'text: firstPaymentPrice',
        '.js-partial-payment-tooltip': 'toggle: show',
    },

    events: {
        'click a': 'userHideTooltip',
    },

    template,
})
export default class PartialPaymentTooltipView extends Backbone.Epoxy.View {
    initialize() {
        this.$el.append(this.template());

        this.initModelEvents();
    }

    initModelEvents() {
        this.model.on('change:filteredTourProducts', this.renderTooltip.bind(this));
    }

    renderTooltip(model, value) {
        if (value?.length) {
            this.showTooltip(value.at(0).get('tour'));
            return;
        }

         this.hideTooltip();
    }

    showTooltip(tour) {
        if (!tour) {
            this.hideTooltip();
            return;
        }

        const percentValue = tour.get('percentValue') || 0;

        this.viewModel.set({
            firstPaymentPrice: `${percentValue * 100}%`,
            show: (!this.viewModel.get('userCloseTooltip') && percentValue),
            price: `${(percentValue * tour.get('priceWithOilTax')).formatNumber()} руб.`,
        });
    }

    userHideTooltip(e) {
        e.preventDefault();

        this.viewModel.set({
            userCloseTooltip: true,
        });

        this.hideTooltip();
    }

    hideTooltip() {
        this.viewModel.set({
            show: false,
        });
    }
}
